module.exports = "/images/vendor/flag-icon-css/flags/1x1/nc.svg?d393b8faea4e68b19f4d3d920480dbcd";